import { Injectable } from '@angular/core'
import { Config } from '../config/config'
import { HttpClient } from '@angular/common/http'
import { Router } from '@angular/router'
import { AuthService } from './auth.service'
import { TokenService } from './token.service'
import { LocalStorageService } from './local-storage.service'
import {Observable} from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class JwtService {

    /**
     * Configurações do sistema.
     */
    private config: Config = new Config

    constructor(
        private http: HttpClient,
        private router: Router,
        private authService: AuthService,
        private tokenService: TokenService,
        private localStorageService: LocalStorageService,
    ) { }

    login(user, password): Observable<any> {
        const data = {
            grant_type: 'password',
            scope: '',
            client_id: this.config.get('clientId'),
            client_secret: this.config.get('clientSecret'),
            username: user,
            password: password
        }
        return this.http.post(this.config.get('urlBackend') + 'api/oauth/token', data)
    }

    logout() {
        this.tokenService.remove()
        this.authService.changeAuthStatus(false)
        this.localStorageService.remove('token')
        this.localStorageService.set('usuario', null)
        this.localStorageService.remove('current_user')
        this.router.navigateByUrl('/login')
    }
}
